var map = {
	"./admin.svg": "BlLF",
	"./date.svg": "Ve8B",
	"./date2.svg": "h0Wj",
	"./default-file.svg": "grLX",
	"./doc.svg": "F2xj",
	"./document.svg": "mDNq",
	"./docx.svg": "t4uj",
	"./email.svg": "+4G4",
	"./excel.svg": "OLl3",
	"./folder-lock-open.svg": "qLKq",
	"./folder.svg": "XXSE",
	"./home.svg": "U9Ws",
	"./lock.svg": "FnAU",
	"./logo.svg": "ZY77",
	"./note.svg": "yZSt",
	"./pdf.svg": "M8Oc",
	"./phone.svg": "7pRf",
	"./ppt.svg": "4hoL",
	"./pptx.svg": "+x/n",
	"./role.svg": "cqqK",
	"./search.svg": "Bx0U",
	"./sector.svg": "NxYr",
	"./stage.svg": "rwuO",
	"./task.svg": "EK3d",
	"./txt.svg": "YXXy",
	"./username.svg": "QS/K",
	"./word.svg": "ELgs",
	"./world.svg": "zRlu",
	"./xls.svg": "U1K1",
	"./xlsx.svg": "+EMO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 12